export default __webpack_public_path__ + "static/media/10.508cb510.jpeg";